import type { HolidayRegion } from "./types.ts";

export type RegionTabConfig = {
  id: HolidayRegion;
  label: string;
  /** Public asset path, or null to render a globe icon in the badge. */
  flagSrc: string | null;
};

/** Tab order: regions first, SQE Labs after UK, Global last. */
export const REGION_TABS: readonly RegionTabConfig[] = [
  { id: "INDIA", label: "India", flagSrc: "/assets/indian-flag.svg" },
  { id: "US", label: "US", flagSrc: "/assets/us-flag.svg" },
  { id: "UK", label: "UK", flagSrc: "/assets/uk-flag.svg" },
  { id: "SQE", label: "SQE Labs", flagSrc: null },
  { id: "GLOBAL", label: "Global", flagSrc: null },
] as const;

export const REGION_LABELS: Record<HolidayRegion, string> = {
  INDIA: "India",
  US: "US",
  UK: "UK",
  SQE: "SQE Labs",
  GLOBAL: "Global",
};

/**
 * Map API `country` / `region` / `shiftType` (any casing) to a canonical HolidayRegion.
 * Empty/missing values map to GLOBAL. Truly unknown region strings return null (hidden from UI).
 */
export function normalizeRegion(
  raw: string | null | undefined,
): HolidayRegion | null {
  if (raw == null || String(raw).trim() === "") return "GLOBAL";

  const v = String(raw).trim().toUpperCase().replace(/\s+/g, "_");

  if (
    v === "INDIA" ||
    v === "IN" ||
    v === "CCI_INDIA" ||
    v === "IRED" ||
    v === "IRED_INDIA"
  ) {
    return "INDIA";
  }
  if (v === "US" || v === "USA" || v === "CCI_US" || v === "UNITED_STATES") {
    return "US";
  }
  if (
    v === "UK" ||
    v === "GB" ||
    v === "UNITED_KINGDOM" ||
    v === "GREAT_BRITAIN" ||
    v === "CCI_UK"
  ) {
    return "UK";
  }
  if (v === "SQE") {
    return "SQE";
  }
  if (v === "GLOBAL" || v === "ALL" || v === "WORLDWIDE" || v === "INTL") {
    return "GLOBAL";
  }

  return null;
}
